import clsx from "clsx";

import type { ColumnsStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import styles from "./columns.module.css";
import isOnlyMedia from "./isOnlyMedia";

const Columns = ({
  blok,
  preview,
}: {
  blok: ColumnsStoryblok;
  preview: boolean;
}): React.JSX.Element => {
  const left = blok.left?.[0];
  const right = blok.right?.[0];

  /** we don't want to allow certain Y position combinations */
  const shouldOverrideY = (() => {
    if (!isOnlyMedia(left, right)) return false; // continue if we only have media components in both columns
    if (left?.position_y === right?.position_y) return true; // we don't allow equal Y positions - overriding
    return false;
  })();

  return (
    <div
      className={clsx(styles.root, "columns-blok")}
      data-layout="blok"
      data-container="small"
    >
      <div className={styles.left}>
        <StoryblokComponent blok={left} preview={preview} />
      </div>
      <div
        className={clsx(
          styles.right,
          shouldOverrideY && styles.y_offset_override
        )}
      >
        <StoryblokComponent blok={right} preview={preview} />
      </div>
    </div>
  );
};

export default Columns;
